<script>
    import { onMount } from 'svelte';
    import { initializeAuth, signIn, signOut } from './authPopUp.js';
    import { token, user } from '../../stores.js';

    // Auth mode is decided at build time via rollup's string replace.
    // 'mock'  — use the local mock-oidc compose service (default)
    // 'entra' — use real MSAL against Microsoft Entra
    //
    // The previous localhost-based detection is gone: this mode is
    // set explicitly by whichever compose file is running. See
    // local/docker-compose.entra.yml for the entra opt-in.
    const authMode = "SECURESHARE_AUTH_MODE";
    const useMockOidc = authMode === "mock";

    user.useLocalStorage();

    function accountReceived(account, access_token) {
        // Deliberately NOT logging the account or access_token here.
        // The account object has PII (username, email, tenant id) and
        // the access token is a bearer credential — either one in the
        // browser console is a replay/credential-theft risk for
        // anyone with DevTools open.
        if (account.name) {
            $user = {
                id: account.homeAccountId,
                name: account.name,
                email: account.username
            };

            $token = access_token;
        }
        else {
            $user = {};
        }
    }

    function logOut() {
        $user = {};
        // Mock-oidc has no logout flow to hit — just clear local state.
        // Real Entra needs MSAL's logout to clear the session cookie.
        if (!useMockOidc) signOut();
    }

    // Local dev: fetch a real RS256 JWT from the mock OIDC provider
    // (navikt/mock-oauth2-server, proxied by nginx at /oidc). This
    // exercises the same auth code path as production — the Flask
    // middleware validates the signature, iss, aud, and exp for real.
    async function loginToMockOidc() {
        const form = new URLSearchParams({
            grant_type: 'client_credentials',
            client_id: 'secureshare-local',
            client_secret: 'secret',
            scope: 'openid'
        });
        const res = await fetch('/oidc/default/token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: form.toString()
        });
        if (!res.ok) throw new Error(`mock oidc login failed: ${res.status}`);
        const data = await res.json();
        return data.access_token;
    }

    onMount(async () => {
        if (useMockOidc) {
            try {
                const accessToken = await loginToMockOidc();
                $user = {
                    id: 'secureshare-local',
                    name: 'Local Dev',
                    email: 'dev@localhost'
                };
                $token = accessToken;
            } catch (e) {
                console.error('Mock OIDC auth failed', e);
                $user = {};
            }
        } else {
            initializeAuth(accountReceived);
        }
    });
</script>

{#if $user.name}
    {$user.name} <br> <div class="fakeAnchor" onclick={logOut}>Log Out</div>
{:else}
    <div class="fakeAnchor" onclick={signIn}>Login</div>
{/if}

<style>
    .fakeAnchor {
        color: rgb(0,100,200);
        text-align: right;
        width: 100%;
    }
        .fakeAnchor:hover {
            color: rgb(0,100,100);
            cursor: pointer;
        }
</style>
